var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isMap,
          expression: "isMap"
        }
      ],
      staticClass: "properties-map"
    },
    [
      _c("div", { staticClass: "properties-map__map" }),
      _vm._v(" "),
      _c("div", { staticClass: "properties-map__popup" }, [
        _c(
          "a",
          {
            staticClass: "properties-map__popup-close",
            on: { click: _vm.clearActiveMarker }
          },
          [_c("i", { staticClass: "icon-close" })]
        ),
        _vm._v(" "),
        _vm.currentMarkerContent
          ? _c("div", {
              staticClass:
                "properties-map__popup-content properties-map__popup-info",
              domProps: { innerHTML: _vm._s(_vm.currentMarkerContent) }
            })
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c18d5ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c18d5ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SearchesMap.vue
// module id = 683
// module chunks = 1